import React from "react";
import loader from "../../assets/logo/loader.gif";

const Loader = () => {
    return(<div className="loader-bg">  
        <img src={loader} alt="Loading..." className="spinner" />  
        </div>)
};

export default Loader;
